<template>
    <section class="scene-intro" id="intro">
        <div class="static-container">
            <h1 class="title">
                <span class="alan">alan chr</span>
                <span class="func">.is()</span>
            </h1>

            <div class="std">
                <p class="-purple">Alan Chris Antony</p>
                <p class="-gray">
                    Passionate python developer
                </p>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'Intro'
    }
</script>